// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  filterAndSortPathIds,
  removeFilteredPathsFromHighlight,
  updateProjectFilter,
} from 'redux/modules/projectSummary'

// update the filter values in redux state
// then update the visiblePathIds list
// then unhighlight any paths which are no longer visible but were highlighted.

const assignProjectFilter = filterValues => (dispatch, getState) => {
  dispatch(updateProjectFilter(filterValues))
  dispatch(filterAndSortPathIds())
  dispatch(removeFilteredPathsFromHighlight())
}

export default assignProjectFilter
